import { CSSProperties, useMemo } from 'react'
import { Model } from '../../../types/mfc'
import { AppStateType } from '../../constants/enums'
import { getModelColor } from '../../utilities/colors'
import { useAppStateSelector } from './useAppState'

export const useModelColor = (hexColor: string) => {
    // TODO: this can probably be rethought as everywhere this is called we're already
    // getting stuff from appstate, so this is just adding another subscription
    const darkMode = useAppStateSelector(AppStateType.APP, 'darkMode')

    const color = getModelColor(hexColor, darkMode)
    // look for users with #585858 based on API calls so they are readable
    if (color === '#585858' && darkMode) return '#ffffff'
    return color
}

export const useModelStyles = ({
    color,
}: Pick<Model, 'color'>): CSSProperties => {
    const darkMode = useAppStateSelector(AppStateType.APP, 'darkMode')
    const styles = useMemo(
        () => ({
            color: getModelColor(color, darkMode),
        }),
        [darkMode, color],
    )
    return styles
}
